import { useEffect, useRef, useState } from 'react';

interface UseVerticalRollProps {
    interval?: number; // 每次切换时间（默认 3000ms）
    duration?: number; // 滚动动画时长（默认 600ms）
    itemHeight?: number; // 每一行高度（默认 40px）
    length: number; // 文案长度（不含克隆项）
}

export function useVerticalRoll({ interval = 3000, duration = 600, itemHeight = 40, length }: UseVerticalRollProps) {
    const [index, setIndex] = useState(0);
    const contentRef = useRef<HTMLDivElement>(null);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // 切换一次
    const move = () => {
        setIndex((prev) => prev + 1);
    };

    // 控制 transform
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        content.style.transition = `transform ${duration}ms ease`;
        content.style.transform = `translateY(-${index * itemHeight}px)`;

        const handleTransitionEnd = () => {
            // 到克隆项 → 无缝重置回第一项
            if (index === length) {
                content.style.transition = 'none';
                content.style.transform = 'translateY(0)';
                content.offsetHeight; // 强制重绘
                content.style.transition = `transform ${duration}ms ease`;

                setIndex(0);
            }
        };

        content.addEventListener('transitionend', handleTransitionEnd);
        return () => content.removeEventListener('transitionend', handleTransitionEnd);
    }, [index, itemHeight, duration, length]);

    // 定时器
    useEffect(() => {
        timerRef.current = setInterval(move, interval);
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [interval]);

    return { contentRef };
}
